import React from "react";
import { useTranslation } from "next-i18next";

import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

import Swipper from "../../../../Swipper/Swipper";
import HomepageV2Animate from "../../../../homepage-v2/animate/HomepageV2Animate";
import HomepageV2SectionCard from "../../../../homepage-v2/section-card/HomepageV2SectionCard";
import WebV2SectionHeader from "../../../../homepage-v2/web-v2-section-header/WebV2SectionHeader";
import { MARKETPLACE_V3_MOBILE_CAROUSEL } from "../marketplaceV3.constants";
import Styles from "./MarketplaceV3WhyChooseSection.module.scss";

type WhyChooseCard = { title: string; description: string };

const MarketplaceV3WhyChooseSection = () => {
    const { t } = useTranslation("marketplaceV3");
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const cardsRaw = t("whyChoose.cards", { returnObjects: true });
    const cards = (Array.isArray(cardsRaw) ? cardsRaw : []) as WhyChooseCard[];

    const renderCard = (card: WhyChooseCard, isCarousel = false) => (
        <article className={isCarousel ? Styles.dotCardCarousel : Styles.dotCard}>
            <span className={Styles.dot} aria-hidden />
            <h3 className={Styles.cardTitle}>{card.title}</h3>
            <p className={Styles.cardDescription}>{card.description}</p>
        </article>
    );

    return (
        <HomepageV2SectionCard variant="white">
            <div className={Styles.container}>
                <HomepageV2Animate variant="fade-up">
                    <WebV2SectionHeader
                        title={t("whyChoose.title")}
                        description={t("whyChoose.description")}
                        align="left"
                        className={Styles.sectionHeader}
                        titleClassName={Styles.title}
                        descriptionClassName={Styles.description}
                    />
                </HomepageV2Animate>

                {isMobileScreen ? (
                    <Swipper
                        className={Styles.cardsSwiper}
                        {...MARKETPLACE_V3_MOBILE_CAROUSEL}
                        list={cards.map((card) => ({
                            key: card.title,
                            node: renderCard(card, true)
                        }))}
                    />
                ) : (
                    <div className={Styles.dotGrid}>
                        {cards.map((card, index) => (
                            <HomepageV2Animate key={card.title} variant="fade-up" delay={index * 90}>
                                {renderCard(card)}
                            </HomepageV2Animate>
                        ))}
                    </div>
                )}
            </div>
        </HomepageV2SectionCard>
    );
};

export default MarketplaceV3WhyChooseSection;
